import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) {
      nav("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, { headers: { "X-Session-ID": sid } });
        localStorage.setItem("cling_token", data.token);
        setUser(data.user);
        window.history.replaceState({}, "", "/");
        toast.success(`Welcome, ${data.user.name}`);
        nav(data.user.onboarded ? "/home" : "/onboarding", { state: { user: data.user } });
      } catch (e) {
        toast.error("Sign-in failed");
        nav("/login");
      }
    })();
  }, [location, nav, setUser]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-center">
        <div className="font-display text-xl">Signing you in…</div>
        <div className="text-sm text-muted-foreground mt-2">One moment.</div>
      </div>
    </div>
  );
}
